export function scoreMrzBand(
  rowEdges: Float32Array,
  guideH: number,
  guideW: number,
  mrzFracs: number[],
  midEdgeDensity: number,
): number {
  let best = 0;
  for (const frac of mrzFracs) {
    const bandStart = Math.floor(guideH * (1 - frac));
    const bandRowCount = guideH - bandStart;
    let sum = 0,
      sumSq = 0;
    for (let row = bandStart; row < guideH; row++) {
      const e = rowEdges[row];
      sum += e;
      sumSq += e * e;
    }
    const density = sum / (bandRowCount * (guideW - 1));
    const mean = sum / bandRowCount;
    const variance = sumSq / bandRowCount - mean * mean;
    const cv = mean > 1 ? Math.sqrt(Math.max(0, variance)) / mean : 2;
    const uniformity = Math.max(0, 1 - cv * 0.6);
    const ratio = density / Math.max(midEdgeDensity, 0.5);
    const abs = Math.min(1, density / 10);
    const rel = Math.min(1, Math.max(0, (ratio - 1.05) / 1.2));
    const score = abs * 0.45 + rel * 0.35 + uniformity * 0.2;
    if (score > best) best = score;
  }
  return best;
}
